import React from "react";
import { RouteComponentProps } from "react-router";
import ClientDetailsPage from "go-component/components/ClientDetails";
import { adminApi } from "go-security/services/Api/adminApi";

export const AdminClientDetailsIndexPage = (props: RouteComponentProps): JSX.Element => {
	const {
		getClientDetails,
		addClientDetail,
		editClientDetail,
		deleteClientDetail,
		getClientScopes,
		getClientGrantTypes,
		getClientSecret,
		getAllClientGrants,
		getClientGrants,
		getClientGrant,
		updateClientGrant,
		createClientGrant,
		revokeClientGrant,
		activateClientGrant,
		removeClientGrant,
	} = adminApi;

	const requests = {
		getClientDetails,
		addClientDetail,
		editClientDetail,
		deleteClientDetail,
		getClientScopes,
		getClientGrantTypes,
		getClientSecret,
		getAllClientGrants,
		getClientGrants,
		getClientGrant,
		updateClientGrant,
		createClientGrant,
		revokeClientGrant,
		activateClientGrant,
		removeClientGrant,
	};

	return <ClientDetailsPage {...props} requests={requests} />;
};
